import SubSectionHeader from "../../elements/SubSectionHeader";
import LineupCardInfoSection from "./LineupCardInfoSection";
import LineupLogosSection from "./LineupLogosSection";

const LineupCardSection = () => {
  return (
    <div className="d-flex">
      <div style={{ width: "100%" }}>
        <SubSectionHeader title="Card Info" />
        <LineupCardInfoSection />
      </div>
      <div style={{ width: "24px" }} />
      <div style={{ width: "100%" }}>
        <SubSectionHeader title="Logos" />
        <LineupLogosSection />
      </div>
    </div>
  );
};

export default LineupCardSection;
